import { useI18n } from '@i18n/useI18n';
import { Content, PopReward, PopRewardContainer, RewardContainer } from './ProfileRewardRedeem.styled';
import { CardTitle, GridCard } from '@components/GridCards/Common.styled';
import RewardItem from './RewardItem';
import { useEffect, useRef, useState } from 'react';
import db from '@utils/db';
import { useStore } from '@store/appStore';
import CardInfo from '@components/GridCards/CardInfo';
import useOnScreen from '@components/Utils/useOnScreen';
import { MoreBox, Reward } from './RewardItem/RewardItem.styled';
import More_Icon from '@assets/svg/redeem/Rewards_V1.svg';
import { HeadLine, PopClose, PopContainer, PopTitle } from '@components/Guardian/Guardian.styled';
import Modal from '@components/Buttons/Modal';
import Close_Icon from "@assets/svg/match/missing.svg";
import RewardPreviewScreen from '@components/Reward/RewardPreviewScreen';
import RewardQRScreen from '@components/Reward/RewardQRScreen';
import RainbowLoader from '@components/Loaders/RainbowLoader';

interface IProps {
  studentId: string;
  isAdmin?: boolean;
  updateTime?: any;
  updateCoins?: () => void
}

export const ProfileRewardRedeem = (props: IProps) => {
  const i18n = useI18n();
  const [profileCoins, setProfileCoins] = useState(0);
  const [rewards, setRewards] = useState(null);
  const { client, settings, systemSettings, rewardPreview, setRewardPreview, rewardQRScreen, badge, setRewardQRScreen } = useStore();
  const ref = useRef<HTMLDivElement>(null);
  const isVisible = useOnScreen(ref);
  const loadingData = useRef(false)
  const [modal, setModal] = useState(false)
  const modalRef = useRef(null);


  useEffect(() => {
    if (isVisible && !loadingData.current) {
      loadingData.current = true
      getCoins();
      getRewards();
    }
  }, [isVisible, props.studentId, props.updateTime])

  useEffect(() => {
    if (loadingData.current && rewardPreview === false) {
      getRewards();
      getCoins();
    }
  }, [rewardPreview]);

  useEffect(() => {
    if (rewardQRScreen === false) {
      getRewards();
      getCoins();
    }
  }, [rewardQRScreen]);

  const getCoins = () => {
    db.Student_Stat_GetCoins(props.studentId, props.isAdmin === true).then((data) => {
      if (data && data.length > 0) {
        let coins = data[0].newcoins + data[0].oldcoins;
        setProfileCoins(coins);
      }
      loadingData.current = false
    });
  };

  let language = systemSettings.find((s) => s.APP_Setting_ID === 16);

  const getRewards = () => {
    db.Student_Stat_GetRewards(props.studentId, language.value).then((data) => {
      setRewards(data);
      loadingData.current = false
    });
  };

  let itemList = [];

  if (rewards && rewards.length > 0) {
    rewards
      .sort((a, b) => a.cost - b.cost)
      .filter(
        (r) => (r.initial_stock === -1 || r.initial_stock - r.total_purchased_count > 0) && (r.limit_pr_user === -1 || r.student_purchased_count < r.limit_pr_user)
      )
      .map((ri, index) =>
        itemList.push(
          <RewardItem
            isAdmin={props.isAdmin}
            key={'rewarditem_' + index}
            profileCoins={profileCoins}
            studentId={props.studentId}
            rewardItem={ri}
          />,
        ),
      );
  }

  return (<>
      {rewardPreview && (
          <RewardPreviewScreen screenTitle={'rewarditempreview'} badge={badge} closeScreen={setRewardPreview}/>
      )}

      {rewardQRScreen && (
          <RewardQRScreen updateCoins={props.updateCoins} screenTitle={'rewarditempreview'} badge={badge} closeScreen={setRewardQRScreen}/>
      )}

      {modal?<Modal ref={modalRef} onClose={setModal} backColor={"rgba(0,0,0,0.25)"}>
        <PopContainer normalPad={true} freeWidth={true} mid={true}>
          <PopTitle>{i18n.t("Alle Rewards")}</PopTitle>
          <PopClose onClick={() => modalRef.current.handleClose()}><Close_Icon /></PopClose>
          <HeadLine />
          <PopRewardContainer freeWidth={true}>
            <PopReward>
              {itemList}
            </PopReward>
          </PopRewardContainer>
        </PopContainer>
      </Modal>:null}


      <GridCard ref={ref} col={2} heightAuto={true}>
        <Content>
          <CardTitle>Attender Rewards</CardTitle>
          <CardInfo text='info-text-rewards' padding={true} />
          <RewardContainer>

            {rewards === null ?
              <RainbowLoader />
              :
              itemList.length <=8?
                itemList
                :
                <>
                  {itemList.slice(0, 7)}
                  <Reward onClick={() => setModal(true)}>
                    <MoreBox>
                      <More_Icon />
                      {i18n.t("view-all-rewards")}
                    </MoreBox>
                  </Reward>
                </>
              }
          </RewardContainer>
        </Content>
      </GridCard>
    </>
  );
};

export default ProfileRewardRedeem;
